import React, { useState } from "react";
import "./MusicPage.css";

const musicApps = [
  {
    id: "piano",
    title: "Magical Keyboard",
    label: "Interactive piano",
    src: "/bonobo-magical-music/Piano.html",
    description:
      "Play a multi-octave keyboard, switch instrument sounds, and try guided songs with visual note prompts.",
  },
  {
    id: "music-box",
    title: "Magical Music Box",
    label: "Listening library",
    src: "/bonobo-magical-music/MusicBox.html",
    description:
      "Choose from a collection of music-box and gentle instrumental pieces for a calmer sound-based experience.",
  },
];

const MusicPage = () => {
  const [activeAppId, setActiveAppId] = useState(musicApps[0].id);
  const activeApp = musicApps.find((app) => app.id === activeAppId) || musicApps[0];

  return (
    <main className="music-page">
      <section className="music-hero" aria-labelledby="music-page-title">
        <div className="music-hero__copy">
          <p className="music-eyebrow">Interactive sound tools</p>
          <h1 id="music-page-title">Bonobo Magical Music</h1>
          <p>
            These two music apps extend the keyboard experience into sound, play,
            memory, and rhythm. Visitors can explore notes directly or listen to
            gentle music-box pieces in a focused, low-friction space.
          </p>
        </div>
        <div className="music-hero__panel" aria-label="Available music apps">
          {musicApps.map((app) => (
            <button
              key={app.id}
              type="button"
              className={`music-app-selector${
                activeApp.id === app.id ? " music-app-selector--active" : ""
              }`}
              onClick={() => setActiveAppId(app.id)}
            >
              <span>{app.label}</span>
              <strong>{app.title}</strong>
            </button>
          ))}
        </div>
      </section>

      <section className="music-live-section" aria-labelledby="music-live-title">
        <div className="music-live-section__head">
          <div>
            <p className="music-eyebrow">Live app</p>
            <h2 id="music-live-title">{activeApp.title}</h2>
            <p>{activeApp.description}</p>
          </div>
          <a
            className="music-open-link"
            href={activeApp.src}
            target="_blank"
            rel="noreferrer"
          >
            Open full page
          </a>
        </div>
        <div className="music-app-frame">
          <iframe
            title={activeApp.title}
            src={activeApp.src}
            loading="lazy"
            allow="autoplay"
          />
        </div>
      </section>

      <section className="music-context" aria-label="Music context">
        <p className="music-eyebrow">Why music belongs here</p>
        <h2>Sound is another shared symbolic environment.</h2>
        <p>
          The lexigram keyboard gives visitors a way to explore arbitrary symbols
          and spoken words. The music tools add a parallel path: tones, patterns,
          memory, timing, and choice. They are not a replacement for the language
          research material; they are another doorway into interactive learning.
        </p>
      </section>
    </main>
  );
};

export default MusicPage;
